var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('v-sheet',[_c('CalendarBase',{attrs:{"categoriesTypes":_vm.categoriesType,"categoriesEvents":_vm.events,"colors":_vm.colors,"intervalCount":_vm.intervalCount,"intervalMinutes":_vm.intervalMin,"valueDateCalendar":_vm.valueDateCalendar,"eventTextColor":_vm.eventTextColor,"redirection":_vm.redirection}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }